angular.module('gm.modals')
.factory('btgConfirmModal', btgConfirmModal);

function btgConfirmModal(
  $q,
  GmyModal
) {
  'ngInject';

  const service = {
    show
  };

  return service;

  function show(title, body, confirmButton) {
    const deferred = $q.defer();

    GmyModal.showModal({
      templateUrl: 'modules/modals/controllers/confirm-modal.html',
      controller: 'ConfirmModalController',
      controllerAs: 'vm',
      inputs: {
        title,
        body,
        confirmButton
      }
    }).then((modal) => {
      modal.closed.then((result) => {
        if (result === 'confirm') {
          deferred.resolve();
        } else {
          deferred.reject();
        }
      });
    });
    return deferred.promise;
  }
}
